import {Loader} from '@orbit-ui/components/loader';
import {useNavigate} from '@tanstack/react-router';
import {useAuth} from '@workos-inc/authkit-react';
import * as React from 'react';

function AuthLogoutView() {
  const {signOut, user, isLoading} = useAuth();
  const navigate = useNavigate({from: '/auth/logout'});

  React.useEffect(() => {
    // wait for user to be loaded before signing out
    if (isLoading) {
      return;
    }

    // if there is no user, redirect to login page
    if (!user) {
      navigate({to: '/auth/login'});
      return;
    }

    // otherwise, sign out
    signOut();
  }, [isLoading, user, navigate, signOut]);

  return <Loader />;
}

export {AuthLogoutView};
